import $ from 'jquery';
import modalFunctions from '../modal-form';

const showForm = $('.js-quote'),
  formModal = $('.form-modal'),
  formInner = $('.form-inner'),
  formWrap = $('.form-modal-wrapper'),
  formModalClose = $('.form-modal .form-modal__close'),
  focusableElements =
    'a, button, input, textarea, select, details, iframe, embed, object, summary dialog, audio[controls], video[controls], [contenteditable], [tabindex]',
  mainContentFocusableEls = $('main').find(focusableElements),
  headerContentFocusableEls = $('header').find(focusableElements),
  footerContentFocusableEls = $('footer').find(focusableElements),
  formFocusableEls = formModal.find(focusableElements),
  htmlEL = $('html'),
  modalArgs = {
    mainContentFocusableEls,
    headerContentFocusableEls,
    footerContentFocusableEls,
    formFocusableEls,
    formModal,
    htmlEL,
  };
modalFunctions.setFormAttr(formModal, formFocusableEls);
showForm.on('click', function (e) {
  modalFunctions.openModal(e, modalArgs);
  $('html, body').css('overflow', 'hidden');
});

formModalClose.on('click', function () {
  modalFunctions.closeModal(modalArgs);
  $('html, body').css('overflow', 'initial');
});

formModal.on('click', function (e) {
  if ($(e.target).is(formInner) || $(e.target).is(this) || $(e.target).is(formWrap)) {
    modalFunctions.closeModal(modalArgs);
    $('html, body').css('overflow', 'initial');
  }
});

$(document).on('keydown', function (e) {
  if (e.key == 'Escape') {
    let modalAria = formModal.attr('aria-hidden');
    if (modalAria) {
      modalFunctions.closeModal(modalArgs);
      $('html, body').css('overflow', 'initial');
    }
  }
});
